const $ = document.querySelector.bind(document);

const CLASS_OPEN = 'is-open';
const NAV_TOGGLE = '.js-nav-toggle';
const NAV_SUB_TOGGLE = '.js-nav__sub-toggle';

const $header = $('.header__nav');
const $nav = $('#nav');

$header.addEventListener('click', function (e) {
    if (e.target.closest(NAV_TOGGLE)) {
        e.preventDefault();

        $nav.classList.toggle(CLASS_OPEN);
    }

    if (e.target.closest(NAV_SUB_TOGGLE)) {
        e.preventDefault();

        const subNavId = e.target.hash;

        $(subNavId).classList.toggle(CLASS_OPEN);
    }
});

// Calendly is only fetched when someone asks to book, not on every page view
const CALENDLY_ASSETS = 'https://assets.calendly.com/assets/external/widget';
const CALENDLY_TIMEOUT = 4000;
let calendlyLoading;

function loadCalendly() {
    if (!calendlyLoading) {
        calendlyLoading = new Promise(function (resolve, reject) {
            const $css = document.createElement('link');
            $css.rel = 'stylesheet';
            $css.href = `${CALENDLY_ASSETS}.css`;
            document.head.appendChild($css);

            const $script = document.createElement('script');
            $script.src = `${CALENDLY_ASSETS}.js`;
            $script.onload = resolve;
            $script.onerror = reject;
            document.head.appendChild($script);

            window.setTimeout(reject, CALENDLY_TIMEOUT);
        }).catch(function (error) {
            // allow a retry on the next click
            calendlyLoading = null;
            throw error;
        });
    }

    return calendlyLoading;
}

document.addEventListener('click', function (e) {
    const $trigger = e.target.closest('.js-book-demo');

    // let modified clicks (new tab / window) follow the link
    if (!$trigger || e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) {
        return;
    }

    e.preventDefault();

    loadCalendly()
        .then(function () {
            window.Calendly.initPopupWidget({ url: $trigger.dataset.calendlyUrl });
        })
        .catch(function () {
            window.location.href = $trigger.href;
        });
});

(function () {
    const STORAGE_KEY = 'cookie-consent';
    const $banner = $('#cookie-consent');

    if (!$banner) {
        return;
    }

    function getConsent() {
        try {
            return window.localStorage.getItem(STORAGE_KEY);
        } catch (e) {
            return null;
        }
    }

    function setConsent(value) {
        try {
            window.localStorage.setItem(STORAGE_KEY, value);
        } catch (e) {
            // ignore — private browsing / storage disabled, banner will just
            // reappear next visit
        }
    }

    const consent = getConsent();

    if (consent === 'accepted') {
        if (typeof window.enableAnalytics === 'function') {
            window.enableAnalytics();
        }
    } else if (consent !== 'declined') {
        $banner.hidden = false;
    }

    $banner.addEventListener('click', function (e) {
        if (e.target.closest('[data-cookie-accept]')) {
            setConsent('accepted');
            $banner.hidden = true;

            if (typeof window.enableAnalytics === 'function') {
                window.enableAnalytics();
            }
        }

        if (e.target.closest('[data-cookie-decline]')) {
            setConsent('declined');
            $banner.hidden = true;
        }
    });
})();

(function () {
    const $bar = $('.js-header-bar');
    const $header = $('.header');

    if (!$bar || !$header) {
        return;
    }

    // expose the bar's real height to CSS (.header__hero spacing, scroll-padding)
    new ResizeObserver(function () {
        document.documentElement.style.setProperty('--header-bar-height', `${$bar.offsetHeight}px`);
    }).observe($bar);

    const SOLID_CLASS = 'js-header-bar--solid';
    const HIDDEN_CLASS = 'js-header-bar--hidden';
    const REVEAL_THRESHOLD = 80;

    // the transparent-fading-to-solid effect only makes sense where there's
    // a photo behind the bar to blend with (the homepage's hero, or a page
    // using the image.hero option) — on a plain blue header there's nothing
    // to blend with, so fading mid-scroll just reads as a glitch; those
    // bars should just stay solid the whole time
    const hasPhotoHero = $header.classList.contains('header--image') || !!$header.closest('.page--home');

    let lastY = window.scrollY;
    let ticking = false;

    if (!hasPhotoHero) {
        $bar.classList.add(SOLID_CLASS);
    }

    function isNavOpen() {
        return $nav.classList.contains(CLASS_OPEN) || $nav.matches(':target');
    }

    function update() {
        const y = window.scrollY;

        if (hasPhotoHero) {
            // go solid once the bar would start covering whatever comes
            // after the header (e.g. the homepage's full-height photo
            // hero) rather than at a flat distance — otherwise a tall
            // hero flashes solid while the photo is still on screen
            // behind it
            const solidThreshold = Math.max(REVEAL_THRESHOLD, $header.offsetHeight - $bar.offsetHeight);

            $bar.classList.toggle(SOLID_CLASS, y > solidThreshold);
        }

        if (isNavOpen() || y <= REVEAL_THRESHOLD || y < lastY) {
            $bar.classList.remove(HIDDEN_CLASS);
        } else if (y > lastY) {
            $bar.classList.add(HIDDEN_CLASS);
        }

        lastY = y;
        ticking = false;
    }

    window.addEventListener('scroll', function () {
        if (!ticking) {
            window.requestAnimationFrame(update);
            ticking = true;
        }
    }, { passive: true });

    // never leave the bar hidden behind a keyboard focus
    $bar.addEventListener('focusin', function () {
        $bar.classList.remove(HIDDEN_CLASS);
    });
})();

document.querySelectorAll('[data-carousel]').forEach(function ($carousel) {
    const $track = $carousel.querySelector('.carousel__track');
    const $slides = [...$carousel.querySelectorAll('.carousel__slide')];
    const interval = Number($carousel.dataset.carouselInterval) || 5000;

    let index = 0;
    let timer;
    let isVisible = false;
    let isHovered = false;
    let isFocused = false;

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function goTo(nextIndex) {
        index = (nextIndex + $slides.length) % $slides.length;

        $track.style.transform = `translateX(-${index * 100}%)`;

        $slides.forEach(($slide, i) => $slide.setAttribute('aria-hidden', String(i !== index)));
    }

    function next() {
        goTo(index + 1);
    }

    function startAutoplay() {
        window.clearInterval(timer);

        if ($slides.length > 1 && isVisible && !isHovered && !isFocused && !reducedMotion.matches) {
            timer = window.setInterval(next, interval);
        }
    }

    $carousel.addEventListener('click', function (e) {
        if (e.target.closest('[data-carousel-next]')) {
            next();
            startAutoplay();
        }

        if (e.target.closest('[data-carousel-prev]')) {
            goTo(index - 1);
            startAutoplay();
        }
    });

    $carousel.addEventListener('mouseenter', function () {
        isHovered = true;
        startAutoplay();
    });

    $carousel.addEventListener('mouseleave', function () {
        isHovered = false;
        startAutoplay();
    });

    // don't move slides while a keyboard user is working the controls
    $carousel.addEventListener('focusin', function () {
        isFocused = true;
        startAutoplay();
    });

    $carousel.addEventListener('focusout', function (e) {
        if (!$carousel.contains(e.relatedTarget)) {
            isFocused = false;
            startAutoplay();
        }
    });

    reducedMotion.addEventListener('change', startAutoplay);

    const $viewportTarget = $carousel.closest('section') || $carousel;

    new IntersectionObserver(function (entries) {
        isVisible = entries[entries.length - 1].isIntersecting;
        startAutoplay();
    }, { threshold: 0, rootMargin: '0px 0px -25% 0px' }).observe($viewportTarget);

    goTo(0);
});

(function () {
    const $nodes = [...document.querySelectorAll('.architecture__node-detail')].map(($detail) => $detail.closest('.architecture__node'));

    // matches the media query that visually hides .architecture__node-detail
    if (!$nodes.length || !window.matchMedia('(min-width: 60rem) and (hover: hover)').matches) {
        return;
    }

    const $tooltip = document.createElement('div');
    $tooltip.className = 'node-tooltip';
    $tooltip.setAttribute('aria-hidden', 'true');
    document.body.appendChild($tooltip);

    let targetX = 0;
    let targetY = 0;
    let curX = 0;
    let curY = 0;
    let following = false;
    let raf = null;

    function setContent($node) {
        const $label = $node.querySelector('.architecture__node-label');
        const title = $label && $label.firstChild ? $label.firstChild.textContent.trim() : '';

        $tooltip.innerHTML = '';

        if (title) {
            const $title = document.createElement('strong');
            $title.className = 'node-tooltip__title';
            $title.textContent = title;
            $tooltip.appendChild($title);
        }

        const $body = document.createElement('p');
        $body.className = 'node-tooltip__body';
        $body.textContent = $node.querySelector('.architecture__node-detail').textContent;
        $tooltip.appendChild($body);
    }

    function loop() {
        curX += (targetX - curX) * 0.2;
        curY += (targetY - curY) * 0.2;

        $tooltip.style.left = curX + 'px';
        $tooltip.style.top = curY + 'px';

        if (following || Math.abs(targetX - curX) > 0.4 || Math.abs(targetY - curY) > 0.4) {
            raf = window.requestAnimationFrame(loop);
        } else {
            raf = null;
        }
    }

    function startLoop() {
        if (!raf) {
            raf = window.requestAnimationFrame(loop);
        }
    }

    $nodes.forEach(function ($node) {
        $node.addEventListener('mouseenter', function (e) {
            setContent($node);
            $tooltip.classList.add(CLASS_OPEN);
            following = true;

            targetX = e.clientX;
            targetY = e.clientY;

            if (!raf) {
                curX = targetX;
                curY = targetY;
            }

            startLoop();
        });

        $node.addEventListener('mousemove', function (e) {
            targetX = e.clientX;
            targetY = e.clientY;

            startLoop();
        });

        $node.addEventListener('mouseleave', function () {
            following = false;
            $tooltip.classList.remove(CLASS_OPEN);
        });

        $node.addEventListener('focus', function () {
            const rect = $node.getBoundingClientRect();

            targetX = rect.left + rect.width / 2;
            targetY = rect.top;
            curX = targetX;
            curY = targetY;

            $tooltip.style.left = curX + 'px';
            $tooltip.style.top = curY + 'px';
            setContent($node);
            $tooltip.classList.add(CLASS_OPEN);
        });

        $node.addEventListener('blur', function () {
            $tooltip.classList.remove(CLASS_OPEN);
        });
    });
})();
